// SCSS imports
// --------------------------------------------------------

import '../scss/index.scss';

// JS imports
// --------------------------------------------------------

import { changeCommentsColorOnToggle, changeTwitterCardTheme, switchTheme } from './darkMode';
import { initPostsSectionCursor } from './postsSectionCursor';
import { createFooterName } from './footer';
import { initHeader } from './header';
import { initMobileSubmenus } from './burger-submenu';
import { initMobileMenu } from './burger-menu';
import { initWorkCardAccordion } from './work-card-accordion';
import { togglePlan } from './togglePlan';
import { calcHeight } from './membership-card';
import { initAuthorsPageCursor } from './authorsPageCursor';
import { initBtnsHover } from './btnsHover';
import { copyToClipboard } from './copyToClipboard';
import { initProgressBar } from './progressBar';
import { loadMore } from './sectionAnimations';
import { animatePostHeader } from './animatePostHeader';

import AOS from 'aos';
import 'aos/dist/aos.css';

// AOS lib

if (typeof disableSectionAnim === 'undefined') {
  AOS.init({
    duration: 600,
    easing: 'ease-out-quart',
    once: true
  });
} else {
  if (disableSectionAnim === true) {
    AOS.init({
      duration: 600,
      easing: 'ease-out-quart',
      once: true
    });
  }
}

const iframe = document.querySelector('#ghost-comments-root iframe');

if (iframe) {
  iframe.addEventListener('load', () => {
    const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

    iframeDoc.head.insertAdjacentHTML(
      'beforeend',
      `<style>
        section.dark button[data-testid="signup-button"] {
          background-color: #fff !important; 
          color: #1d1d1f !important;
        }

        section.dark button[data-testid="signin-button"] {
          color: inherit !important;
        }

        section[data-testid="cta-box"] h1:first-child{
          color: var(--gh-accent-color);
        }

        section[data-testid="cta-box"] p{
          color: var(--gh-accent-color);
          opacity: 0.8;
        }

        section.dark section[data-testid="cta-box"] h1:first-child,
        section.dark section[data-testid="cta-box"] p{
          color: #ffffffd9;
        }

      </style>`
    );
  });
}

// Header script
// --------------------------------------------------------

initHeader();
window.addEventListener('resize', initHeader);

// Mobile menu script
// --------------------------------------------------------

initMobileMenu();
initMobileSubmenus();

// Define font-size for author name in footer
// --------------------------------------------------------

createFooterName();

// Dark mode scripts
// --------------------------------------------------------

const switchThemeBtns = document.querySelectorAll('.switch-theme-btn');

if (switchThemeBtns) {
  switchThemeBtns.forEach((switchThemeBtn) => {
    switchThemeBtn.addEventListener('click', switchTheme);
  });
}

window.addEventListener('load', changeTwitterCardTheme);
window.addEventListener('load', changeCommentsColorOnToggle);

// Add custom cursor for posts section
// --------------------------------------------------------

initPostsSectionCursor();

// Add custom cursor for authors page
// --------------------------------------------------------

initAuthorsPageCursor();

// Script add animation for accordion in work card
// --------------------------------------------------------

const workExpSection = document.querySelector('.work-experience-section');

if (workExpSection) {
  initWorkCardAccordion();
}

// Function that init Intersection Observer for section animation on home page
// --------------------------------------------------------

loadMore();

// Function that toggles yearly/monthly plan on membership page
// --------------------------------------------------------

const membershipPage = document.querySelector('.membership-page');

if (membershipPage) {
  togglePlan(membershipPage);
  calcHeight();
}

// TEST BTN HOVER

initBtnsHover();

// Copy to clipboard button script
// --------------------------------------------------------

copyToClipboard();

// Progress Bar Script
// --------------------------------------------------------

initProgressBar();

// Test post header animate
// --------------------------------------------------------

window.addEventListener('scroll', animatePostHeader);
